import { isCanada } from 'app/common/websiteCountry';
import { getLocale } from 'locales/utils';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { AddEngineHoursDialog } from './Dialogs/ChangeEngineHours';
import { ClockIcon } from 'app/components/icons';
import useFlag from 'app/hooks/useFlag';
import useHasAccessSharingPermissions from 'app/hooks/useHasAccessSharingPermissions';
import { FeatureName } from 'types/entities/MobileSettings';
import './EquipmentDetailsBox.less';

interface IProps {
  eqipmentDetails: any;
  openEngineHoursUpdateDialog: boolean;
  setOpenEngineHoursUpdateDialog: any;
  openNewMaintenanceDialog?: any;
}

export function EquipmentDetails(props: IProps) {
  const { t, i18n } = useTranslation();

  const isAccessSharingFeatureEnabled = useFlag(FeatureName.ACCESS_SHARING);
  const hasAccess = useHasAccessSharingPermissions(props.eqipmentDetails.role);

  const isEditingAllowed =
    (isAccessSharingFeatureEnabled && hasAccess('editMaintenance')) ||
    !isAccessSharingFeatureEnabled;

  const [shoulRedirect, setSouldRedirect] = React.useState<boolean>(true);

  React.useEffect(() => {
    setSouldRedirect(true);
  }, []);

  const locale = getLocale();

  const formatFrHours = hours => {
    return hours.toString().replace('.', t('hours_separator'));
  };

  const getHours = () => {
    const currentEngineHours =
      props.eqipmentDetails.telematics?.cumulativeOperatingHours ||
      props.eqipmentDetails.userEnteredEngineHours;

    return isCanada ||
      locale === 'fr-CA' ||
      locale === 'en-CA' ||
      i18n.language === 'fr'
      ? formatFrHours(currentEngineHours)
      : currentEngineHours;
  };

  const handleEdit = () => {
    props.setOpenEngineHoursUpdateDialog(true);
    setSouldRedirect(false);
  };

  return (
    <div className="info-cards-row">
      <div className="info-card info-card-engine-hours">
        <div className="engine-hours">
          <div className="info-card-label">
            {t('select_maintenance_current_engine_hours')}
          </div>
          {!props.eqipmentDetails.hasTelematics && isEditingAllowed && (
            <svg
              onClick={handleEdit}
              id="ic_maintenance_edit"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <rect id="Box" width="20" height="20" fill="none" />
              <g id="edit-2" transform="translate(4.528 4)">
                <path
                  id="Vector"
                  d="M5.633.875.64,6.159a1.854,1.854,0,0,0-.407.87L.008,9a.929.929,0,0,0,1.137,1.076L3.1,9.74a1.746,1.746,0,0,0,.845-.456L8.94,4A1.981,1.981,0,0,0,8.849.778,1.982,1.982,0,0,0,5.633.875Z"
                  transform="translate(0.606 0)"
                  fill="none"
                  stroke="#1a1a1a"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
                <path
                  id="Vector-2"
                  data-name="Vector"
                  d="M0,0A3.725,3.725,0,0,0,3.314,3.131"
                  transform="translate(5.406 1.757)"
                  fill="none"
                  stroke="#1a1a1a"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
                <path
                  id="Vector-3"
                  data-name="Vector"
                  d="M0,0H10.945"
                  transform="translate(0 12.063)"
                  fill="none"
                  stroke="#1a1a1a"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
              </g>
            </svg>
          )}
        </div>
        <div className="engine-hours">
          <ClockIcon className="equipment-details-box__clock_icon" />
          <div className="ellipsis">{getHours()}</div>
        </div>
      </div>
      <div className="info-card row">
        <div className="col-md-12">
          <span className="info-col-label">{t('equipment_model')}</span>
          <span className="info-col-value">{props.eqipmentDetails.model}</span>
        </div>
        <div className="col-md-12">
          <span className="info-col-label">
            {props.eqipmentDetails.pin
              ? t('equipment_pin')
              : t('equipment_serial')}
          </span>
          <span className="info-col-value">
            {props.eqipmentDetails.pinOrSerial || '\u00A0'}{' '}
          </span>
        </div>
      </div>
      {props.openEngineHoursUpdateDialog && (
        <AddEngineHoursDialog
          isVisible={props.openEngineHoursUpdateDialog}
          setVisible={props.setOpenEngineHoursUpdateDialog}
          openNewMaintenanceDialog={props.openNewMaintenanceDialog}
          shouldRedirect={shoulRedirect}
          redirect={() => setSouldRedirect(true)}
        />
      )}
    </div>
  );
}
